import { MenuVariant } from '@/types/menu.types'
import { menuConfig } from '@/ui/components/navbar/config'

interface HamburgerButtonProps {
  isOpen: boolean
  onToggle: () => void
  variant: MenuVariant
}

const HamburgerButton = ({
  isOpen,
  onToggle,
  variant,
}: HamburgerButtonProps) => {
  // Une fois ouvert, le panneau est sombre : la croix passe en clair.
  const isDark = isOpen || menuConfig[variant]?.tone === 'dark'

  return (
    <button
      onClick={onToggle}
      aria-label={isOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
      aria-expanded={isOpen}
      className={`relative z-50 -mr-2 flex size-11 items-center justify-center desktop:hidden ${
        isDark ? 'text-chalk' : 'text-ink'
      }`}
    >
      <span className="relative block h-3.5 w-6">
        <span
          aria-hidden="true"
          className={`absolute left-0 block h-px w-full bg-current transition-transform duration-300 ${
            isOpen ? 'top-1/2 rotate-45' : 'top-0'
          }`}
        />
        <span
          aria-hidden="true"
          className={`absolute left-0 block h-px w-full bg-current transition-transform duration-300 ${
            isOpen ? 'top-1/2 -rotate-45' : 'top-full'
          }`}
        />
      </span>
    </button>
  )
}

export default HamburgerButton
